import { ReactNode } from 'react'

interface OptionsTypes {
  id: string
  label: string
  value: number | string | boolean
  name?: string
}

interface TextProps {
  id: string
  type: 'number' | 'text' | 'password' | 'email' | 'decimal' | undefined
  label?: string
  placeholder?: string
  min?: number
  max?: number
  rightLabel?: string
  className?: string
  numericMode?: boolean
}

export interface surveyDataFieldsType {
  id: string | number
  questionNumber?: number
  question: string
  additionalLabel?: { text: string | ReactNode; classes?: string }[]
  additionalQuestionLabelClasses?: string
  requiredType: 'required' | 'optional'
  fieldType: 'radio' | 'checkbox' | 'inputText' | 'select' | 'textArea'
  answerOptions?: OptionsTypes[]
  answerOptionsByCategory?: { category: string; options: OptionsTypes[] }[]
  textProps?: TextProps[]
  selectOptions?: { value: string | number; label: string }[]
  selectOptionsByCategory?: {
    category: string
    options: { value: string | number; label: string }[]
  }[]
}

export interface FormValues {
  id?: string | number
  dateOfBirth?: string
  consentInfoSharing: number | null //q1
  ownMobilePhone: number //q2
  desiredSalary: string //q3
  transportation: number[] //q4
  qualification: number[] //q5
  otherQualification: string //q5
  manufacturingExperience: number //q6
  medicalHistories: number[] //q7
  otherMedicalHistory: string
  disabilityCertificate: number[] //q8
  otherDisabilityCertificateChecked: boolean //q8
  otherDisabilityCertificate: string //q8
  hasTattoo: number //q9
  jacketSize: number //q10
  pantsSize: number //q10
  leftGripStrength: number //q11
  rightGripStrength: number //q11
  vision: number
  leftEyeSight: number | null //q12
  rightEyeSight: number | null //q12
  recentWorkExperience: { companyName: string; duration: string; role: string } // q13
  awardsAndDisciplinaryAction: number //q14
  relationWithAntisocialForces: number //q15
  message: string //q16
  isValidated: boolean
}

export interface RPMDataFields {
  applicant_id: string | number
  free_1675: string // q1 / consent info sharing
  free_1225: string // q2 / own mobile phone
  free_1624: string // q3  / desired salary
  free_1525: string[] // q4  / transportation
  free_1526: string[] // q5  / qualifications
  free_866: string // q5  / other qualifications
  free_10: string // q6  / manufacturing experience
  free_1302: string[] // q7  / medical histories
  free_1303: string // q7  / other medical histories
  free_802: string[] // q8  / disability certificate
  free_803: string // q8  / other disability certificate
  free_1224: string // q9  / tattoo
  free_810: string // q10 / jacket size
  free_811: string // q10  / pants size
  free_1218: string // q11  / grip strength left and right
  free_795: string // q12  / vision
  free_797: string // q12  / left vision
  free_796: string // q12  / right vision
  free_756: string // q13  / recent work company name
  free_768: string // q13  / recent work duration
  free_762: string // q13  / recent work job role
  free_1677: string // q14  / awards and dsciplinary actions
  free_1648: string // q15  / relationship with anti-social forces
  free_1676: string // q16  / message
}

export const initialValues: FormValues = {
  consentInfoSharing: null,
  ownMobilePhone: 0,
  desiredSalary: '',
  transportation: [],
  qualification: [],
  otherQualification: '',
  manufacturingExperience: 0,
  medicalHistories: [],
  otherMedicalHistory: '',
  disabilityCertificate: [],
  otherDisabilityCertificateChecked: false,
  otherDisabilityCertificate: '',
  hasTattoo: 0,
  jacketSize: 0,
  pantsSize: 0,
  leftGripStrength: 0,
  rightGripStrength: 0,
  vision: 0,
  leftEyeSight: 0,
  rightEyeSight: 0,
  recentWorkExperience: { companyName: '', duration: '', role: '' },
  awardsAndDisciplinaryAction: 0,
  relationWithAntisocialForces: 0,
  message: '',
  isValidated: false,
}
